//paiePage.js/:

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Menu from './Menu';
import '../CSS/PaiePage.css';
import {
    Container,
    Box,
    Typography,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TextField,
    MenuItem
} from '@mui/material';
import apiUrl from '../config';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { CircularProgress } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import LayoutDashboard from '../layout/LayoutDashboard';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

const PaiePage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [fichePaie, setFichePaie] = useState([]);
    const [selectedUser, setSelectedUser] = useState('all');
    const [users, setUsers] = useState([]);
    const [isAdmin, setIsAdmin] = useState(false);
    const [currentUserId, setCurrentUserId] = useState(null);
    const [notification, setNotification] = useState({ open: false, message: '', severity: 'success' });
    const [openDialog, setOpenDialog] = useState(false);
    const [ficheToDelete, setFicheToDelete] = useState(null);
    const [loading, setLoading] = useState(true);
    const [loadingAdmin, setLoadingAdmin] = useState(false);
    const [deleting, setDeleting] = useState(false); // pour afficher "merci de patienter..." pendant suppression
    const [openAddDialog, setOpenAddDialog] = useState(false);
const [datePaye, setDatePaye] = useState('');
const [pdfFile, setPdfFile] = useState(null);
const [uploading, setUploading] = useState(false);


    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) {
            navigate('/login');
            return;
        }

        const decodedToken = JSON.parse(atob(token.split('.')[1]));
        setIsAdmin(decodedToken.role === 'ADMIN');
        setCurrentUserId(decodedToken.user_id);

        const fetchUsers = async () => {
  try {
    const response = await axios.get(`${apiUrl}/users-declarations`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    setUsers(response.data);

    return Promise.resolve();
  } catch (error) {
    console.error('Erreur lors du chargement des utilisateurs:', error);
    return Promise.reject();
  }
};
          if (decodedToken.role === 'ADMIN') {
    fetchUsers().then(() => {

        const userIdFromState = location.state?.userId;

        if (userIdFromState) {
            setSelectedUser(userIdFromState);
            handleUserSelection(userIdFromState);
        } else {
            setSelectedUser('all');
            handleUserSelection('all');
        }

    });

} else {

    // USER
    const token = localStorage.getItem('token');

    axios.get(`${apiUrl}/fiche-paie/${decodedToken.user_id}`, {
        headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
        setFichePaie(response.data);
    })
    .catch((error) => {
        console.error("Erreur chargement fiche paie:", error);
    })
    .finally(() => {
        setLoading(false);
    });

}
    }, [navigate, location.state?.userId]);

    const fetchFichePaie = async () => {
        const userIdToFetch = isAdmin ? selectedUser : currentUserId;
        if (userIdToFetch) {
            try {
                const token = localStorage.getItem('token');
                const response = await axios.get(`${apiUrl}/fiche-paie/${userIdToFetch}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setFichePaie(response.data);
            } catch (error) {
                console.error('Erreur lors du chargement des fiches de paie:', error);
            } finally {
                setLoading(false);
                setLoadingAdmin(false);
            }
        }
    };

    const handleUserSelection = async (userId) => {
        setSelectedUser(userId);
        setLoadingAdmin(true);
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            let response;
            if (userId === 'all') {
                response = await axios.get(`${apiUrl}/fiche-paie/all`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            } else {
                response = await axios.get(`${apiUrl}/fiche-paie/${userId}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
            setFichePaie(response.data);
        } catch (error) {
            console.error('Erreur lors du chargement des fiches de paie:', error);
        } finally {
            setLoading(false);
            setLoadingAdmin(false);
        }
    };    

    useEffect(() => {
        const fetchFichePaie = async () => {
            const userIdToFetch = isAdmin ? selectedUser : currentUserId;
            if (userIdToFetch) {
                try {
                    const token = localStorage.getItem('token');
                    const response = await axios.get(`${apiUrl}/fiche-paie/${userIdToFetch}`, {
                        headers: { Authorization: `Bearer ${token}` },
                    });
                    setFichePaie(response.data);
                } catch (error) {
                    console.error('Erreur lors du chargement des fiches de paie:', error);
                } finally {
                    setLoading(false);
                }
            }
        };

        if (!isAdmin) {
            fetchFichePaie();
        }
    }, [selectedUser, isAdmin, currentUserId, location.state?.userId]);

    const handleDownload = async (ficheId) => {
        const token = localStorage.getItem('token');
        try {
            const response = await axios.get(`${apiUrl}/fiche-paie/download/${ficheId}`, {
                headers: { Authorization: `Bearer ${token}` },
                responseType: 'blob',
            });
            const urlBlob = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = urlBlob;
            link.setAttribute('download', `fiche_de_paie_${ficheId}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        } catch (error) {
            console.error('Erreur lors du téléchargement de la fiche de paie:', error);
            setNotification({ open: true, message: 'Erreur lors du téléchargement de la fiche de paie', severity: 'error' });
        }
    };

    const handleConfirmDelete = async () => {
        setDeleting(true); // active le message
        try {
          const token = localStorage.getItem('token');
          await axios.delete(`${apiUrl}/fiche-paie/${ficheToDelete}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          setNotification({ open: true, message: 'Fiche de paie supprimée avec succès.', severity: 'success' });
          setFicheToDelete(null);
          setOpenDialog(false);
          fetchFichePaie();
        } catch (error) {
          console.error('Erreur lors de la suppression de la fiche de paie:', error);
          setNotification({ open: true, message: 'Erreur lors de la suppression de la fiche de paie.', severity: 'error' });
        } finally {
          setDeleting(false); // désactive le message
        }
      };      

    const confirmDelete = (ficheId) => {
        setFicheToDelete(ficheId);
        setOpenDialog(true);
    };

    const handleNavigateAjouter = () => {
    if (isAdmin && (!selectedUser || selectedUser === 'all' || selectedUser === '')) {
        setNotification({
            open: true,
            message: 'Veuillez sélectionner un utilisateur avant d’ajouter une fiche de paie.',
            severity: 'error'
        });
        return;
    }

    navigate('/AjouterPaie', {
        state: {
            userId: isAdmin ? selectedUser : currentUserId
        }
    });
};


const handleUploadPaie = async () => {

if (!datePaye || !pdfFile) {
setNotification({
open: true,
message: "Veuillez remplir tous les champs.",
severity: "error"
});
return;
}

setUploading(true);

try {

const token = localStorage.getItem("token");

const formData = new FormData();
formData.append("Id_Utilisateur", isAdmin ? selectedUser : currentUserId);
formData.append("Date_Paye", datePaye);
formData.append("url_paie", pdfFile);
formData.append("nom", pdfFile.name);

await axios.post(`${apiUrl}/fiche-paie`, formData, {
headers: {
Authorization: `Bearer ${token}`,
"Content-Type": "multipart/form-data"
}
});

setNotification({
open: true,
message: "Fiche de paie ajoutée avec succès",
severity: "success"
});

setOpenAddDialog(false);
setDatePaye("");
setPdfFile(null);

fetchFichePaie();

} catch (error) {

setNotification({
open: true,
message: "Erreur lors de l'ajout",
severity: "error"
});

} finally {
setUploading(false);
}

};

    return (
<LayoutDashboard>

<div className="paie-page">
                <div className="header">
                    <Typography variant="h1" gutterBottom align="center" sx={{ color: '#1f6391' }}>Fiches de Paie</Typography>
                </div>
                <Container maxWidth="lg" sx={{ p: 3 }}>

                    <Button
variant="contained"
onClick={() => {

if (isAdmin && (!selectedUser || selectedUser === 'all')) {

setNotification({
open:true,
message:"Veuillez sélectionner un utilisateur.",
severity:"error"
});

return;

}

setOpenAddDialog(true);

}}
sx={{ bgcolor:'#1f6391', color:'white', mb:2 }}
>
+ Ajouter Fiche de Paie
</Button>
                    {isAdmin && (
                        <Box sx={{ mb: 2 }}>
                            <Typography variant="h6" gutterBottom sx={{ color: '#0B349D' }}>Choisir un utilisateur</Typography>
                            <TextField
    select
    value={selectedUser ?? 'all'}
    onChange={(e) => {
        setSelectedUser(e.target.value);
        handleUserSelection(e.target.value);
    }}
    fullWidth
    variant="outlined"
    sx={{ bgcolor: 'white', mb: 2, borderRadius: '4px', '& fieldset': { border: '1px solid black' }}
}>
    <MenuItem value="all">Tous</MenuItem> {/* Option Tous manuelle */}
    
    {users.length > 0 && users.map((user) => (
        <MenuItem key={user.id} value={user.id}>
            {user.nom} {user.prenom}
        </MenuItem>
    ))}
</TextField>
                        </Box>
                    )}
                    
                   <TableContainer component={Paper} sx={{ overflowX: "auto" }}>
                        <Table sx={{ minWidth: 650 }}>
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ color: '#1f6391', fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>Date de Paiement</TableCell>
                                    <TableCell style={{ color: '#1f6391', fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>Date de Dépôt</TableCell>
                                    <TableCell style={{ color: '#1f6391', fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>Nom du Fichier</TableCell>
                                    <TableCell style={{ color: '#1f6391', fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>Télécharger</TableCell>
                                    <TableCell style={{ color: '#1f6391', fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>Supprimer</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {fichePaie.map((fiche) => (
                                    <TableRow key={fiche.Id_Paye}>
                                        <TableCell>{new Date(fiche.Date_Paye).toLocaleDateString()}</TableCell>
                                        <TableCell>{new Date(fiche.date_de_depot).toLocaleDateString()}</TableCell>
                                        <TableCell>{fiche.nom}</TableCell>
                                        <TableCell>
                                            <Button onClick={() => handleDownload(fiche.Id_Paye)} variant="outlined" sx={{ color: '#1f6391' }}>Télécharger</Button>
                                        </TableCell>
                                        <TableCell>
                                            <Button onClick={() => confirmDelete(fiche.Id_Paye)} variant="outlined" sx={{ color: '#1f6391' }}>Supprimer</Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                                {fichePaie.length === 0 && !loading && (
    <TableRow>
      <TableCell colSpan={5} align="center" style={{ color: '#999', fontStyle: 'italic', padding: '20px' }}>
        Aucun document disponible.
      </TableCell>
    </TableRow>
  )}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    {(loadingAdmin || loading) && (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 2 }}>
                            <Snackbar open={loadingAdmin || loading} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} autoHideDuration={null}>
                                <Alert severity="info" sx={{ width: '100%', fontSize: '1rem', fontWeight: 'bold', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    
                                    Merci de patienter...
                                </Alert>
                            </Snackbar>
                        </Box>
                    )}

                    
                </Container>
                
                {deleting && (
  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 2 }}>
    <Snackbar
      open={true}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      autoHideDuration={null}
    >
      <Alert
        severity="info"
        sx={{
          width: '100%',
          fontSize: '1rem',
          fontWeight: 'bold',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        Merci de patienter...
      </Alert>
    </Snackbar>
  </Box>
)}
                <Snackbar
                    open={notification.open}
                    autoHideDuration={3000}
                    onClose={() => setNotification({ ...notification, open: false })}
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                >
                    <Alert severity={notification.severity} sx={{ width: '100%', fontSize: '1.2rem', fontWeight: 'bold', display: 'flex', justifyContent: 'center', alignItems: 'center', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)', borderRadius: '8px' }}>
                        {notification.message}
                    </Alert>
                </Snackbar>

                <Dialog
                    open={openDialog}
                    onClose={() => setOpenDialog(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title" sx={{ textAlign: 'center', fontWeight: 'bold', color: '#1f6391' }}>
                        Confirmation de suppression
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description" sx={{ textAlign: 'center', fontSize: '1.2rem' }}>
                            Êtes-vous sûr de vouloir supprimer cette fiche de paie ?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions sx={{ justifyContent: 'center', gap: '1rem' }}>
                        <Button onClick={() => setOpenDialog(false)} variant="outlined" sx={{ color: '#1f6391', borderColor: '#1f6391' }}>Annuler</Button>
                        <Button onClick={handleConfirmDelete} variant="contained" sx={{ bgcolor: '#1f6391', color: 'white' }}>Confirmer</Button>
                    </DialogActions>
                </Dialog>
            </div>
           <Dialog
open={openAddDialog}
onClose={() => setOpenAddDialog(false)}
fullWidth
maxWidth="sm"
>

<DialogTitle sx={{ fontWeight:"bold", color:"#1f6391", textAlign:"center" }}>
Ajouter une fiche de paie
</DialogTitle>

<DialogContent>

<Box sx={{
display:"flex",
flexDirection:"column",
gap:2,
mt:1
}}>

<LocalizationProvider dateAdapter={AdapterDayjs}>
<DatePicker
label="Date de paiement"
value={datePaye ? dayjs(datePaye) : null}
onChange={(newValue)=>{
if(newValue){
setDatePaye(newValue.format("YYYY-MM-DD"));
}
}}
slotProps={{
textField:{
fullWidth:true
}
}}
/>
</LocalizationProvider>

<Button
variant="outlined"
component="label"
sx={{
borderColor:"#1f6391",
color:"#1f6391",
height:"48px"
}}
>
Choisir le PDF

<input
type="file"
hidden
accept=".pdf"
onChange={(e)=>setPdfFile(e.target.files[0])}
/>

</Button>

{pdfFile && (
<Typography sx={{ fontSize:"0.9rem", color:"#666" }}>
{pdfFile.name}
</Typography>
)}

</Box>

</DialogContent>

<DialogActions sx={{ justifyContent:"center", pb:2 }}>

<Button
onClick={()=>setOpenAddDialog(false)}
variant="outlined"
sx={{ borderColor:"#1f6391", color:"#1f6391" }}
>
Annuler
</Button>

<Button
variant="contained"
onClick={handleUploadPaie}
sx={{ bgcolor:"#1f6391" }}
>
Ajouter
</Button>

</DialogActions>

</Dialog>
       </LayoutDashboard>
    );
};

export default PaiePage;